import { LoyaltyService } from '@/shared/api/service';

export class LoyaltyApi {
  static async getBonuses(restaurantId: number): Promise<number> {
    return LoyaltyService.v1UserBonusesRetrieve({ restaurantId }).then(
      (resp) => resp.bonuses
    );
  }
}
